// Lys BOD (N-DT): `/v1/finance/bod` → một dòng mỗi tháng. Sau quyền money (worker trả 403 → DataError 'noperm').
// Worker trả { revenue: [{month,docs,revenue,total}], cost: [{month,docs,cost}] } (VND, tháng 'YYYY-MM'); màn dùng triệu ₫.
import type { ApiRoute } from '@hana/data';

export interface BodMonth { id: string; docs: number; jdn?: number; rev: number; cost: number }

type Row = Record<string, unknown>;
const num = (v: unknown): number => { const n = typeof v === 'string' ? Number(v) : v; return typeof n === 'number' && Number.isFinite(n) ? n : 0; };
const tr = (v: unknown): number => Math.round(num(v) / 1e5) / 10;
const rows = (v: unknown): Row[] => (Array.isArray(v) ? (v as Row[]) : []);

export function bodMonthsFromApi(json: unknown): BodMonth[] {
  const j = (json ?? {}) as { revenue?: unknown; cost?: unknown };
  const by = new Map<string, BodMonth>();
  const at = (id: unknown): BodMonth | undefined => {
    if (typeof id !== 'string' || !/^\d{4}-\d{2}$/.test(id)) return undefined;
    let m = by.get(id);
    if (!m) by.set(id, (m = { id, docs: 0, rev: 0, cost: 0 }));
    return m;
  };
  for (const r of rows(j.revenue)) { const m = at(r.month); if (m) { m.docs = num(r.docs); m.rev = tr(r.revenue); } }
  for (const r of rows(j.cost)) { const m = at(r.month); if (m) m.cost = tr(r.cost); }
  return [...by.values()].sort((a, b) => a.id.localeCompare(b.id));
}

export const bodApiRoute: ApiRoute<BodMonth> = {
  path: '/api/v1/finance/bod',
  query: () => ({ months: 13 }),
  parse: (json) => ({ items: bodMonthsFromApi(json), hasMore: false }),
};

declare module '@hana/data' {
  interface Entities {
    /** doanh thu / chi phí theo tháng (api: /v1/finance/bod), triệu ₫ */
    bodMonth: BodMonth;
  }
}
